import type { ComponentProps, ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { AppText } from "./AppText";
import { Icon } from "./Icon";
import {
  radii,
  spacing,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ComponentProps<typeof Icon>["name"];
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.wrap}>
      {icon ? (
        <View style={stylesheet.iconChip}>
          <Icon name={icon} size="md" tone="muted" />
        </View>
      ) : null}
      <AppText weight="semibold" style={stylesheet.centre}>
        {title}
      </AppText>
      {description ? (
        <AppText size="sm" tone="muted" style={stylesheet.centre}>
          {description}
        </AppText>
      ) : null}
      {action ? <View style={stylesheet.action}>{action}</View> : null}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    wrap: {
      alignItems: "center",
      justifyContent: "center",
      gap: spacing.s,
      paddingVertical: spacing.xxl,
      paddingHorizontal: spacing.l,
      borderWidth: 1,
      borderStyle: "dashed",
      borderColor: colors.border,
      borderRadius: radii.card,
      backgroundColor: colors.surfaceSunken,
    },
    iconChip: {
      width: 40,
      height: 40,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: radii.m,
      backgroundColor: colors.background,
      marginBottom: spacing.xs,
    },
    centre: { textAlign: "center" },
    action: { marginTop: spacing.s },
  });
